module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>mail</title><path d=\"M3.28,10a3.5,3.5,0,0,0-1.42.29l21.8,18.43a2,2,0,0,0,2.25,0L47.72,10.31A3.53,3.53,0,0,0,46.3,10ZM.17,11.91a3.47,3.47,0,0,0-.38,1.57V36.54A3.46,3.46,0,0,0,3.28,40h43a3.47,3.47,0,0,0,3.49-3.46V13.48a3.47,3.47,0,0,0-.38-1.57l-22,18.58a4.12,4.12,0,0,1-5.27,0Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mail.svg
// module id = 566
// module chunks = 1